
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/z-index.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_187_1_Notification";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_187_1_Notification__root","animatorContent":"wds_1_187_1_Notification__animatorContent","wrapper":"wds_1_187_1_Notification__wrapper","notification":"wds_1_187_1_Notification__notification","animator":"wds_1_187_1_Notification__animator","labelWrapper":"wds_1_187_1_Notification__labelWrapper","label":"wds_1_187_1_Notification__label","button":"wds_1_187_1_Notification__button","textLink":"wds_1_187_1_Notification__textLink","iconStyling":"wds_1_187_1_Notification__iconStyling","closeButton":"wds_1_187_1_Notification__closeButton"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




